module.exports = __webpack_public_path__ + "static/media/423599957_387493393900983_6978069636748560590_n.7cae4591.jpg";